<template>
  <div class="exercise-wrapper">
    <div class="list" v-if="exercises.length">
      <div class="item" v-for="(item, index) in exercises" :key="index">
        <div class="title-div">
          <span class="title">{{ index + 1 }}.{{ item.question }}</span>
          <span class="type"
            >（{{
              item.exerciseType === 1
                ? "单选题"
                : item.exerciseType === 2
                ? "多选题"
                : item.exerciseType === 3
                ? "主观题"
                : ""
            }}）</span
          >
        </div>
        <div class="img" v-if="item.fileUrl">
          <van-image
            :src="item.fileUrl"
            width="200px"
            height="100px"
            @click="lookBigImg(item)"
          ></van-image>
        </div>
        <div class="xuanxiang">
          <!-- 单选 -->
          <template v-if="item.exerciseType === 1">
            <van-radio-group v-model="item.userChooseIds">
              <van-radio
                :name="opt.exerciseId"
                v-for="opt in item.options"
                :key="opt.exerciseId"
                checked-color="#0f3cc6"
                >{{ opt.option }}</van-radio
              >
            </van-radio-group>
          </template>
          <!-- 多选 -->
          <template v-if="item.exerciseType === 2">
            <van-checkbox-group v-model="item.userChooseIds">
              <van-checkbox
                :name="opt.exerciseId"
                v-for="opt in item.options"
                :key="opt.exerciseId"
                checked-color="#0f3cc6"
                >{{ opt.option }}</van-checkbox
              >
            </van-checkbox-group>
          </template>
          <!-- 主观题 -->
          <template v-if="item.exerciseType === 3">
            <van-field
              v-model="item.userInput"
              rows="3"
              autosize
              type="textarea"
              placeholder="请输入..."
              :maxlength="300"
              show-word-limit
            />
          </template>
        </div>
        <!-- 答案 -->
        <div class="answerDiv" v-if="readonly">
          <!-- 选择题 -->
          <template v-if="item.exerciseType !== 3">
            <span v-if="item.userChoose.length">
              你的答案：<span
                span
                :class="item.answerRight ? 'true' : 'false'"
                v-for="i in item.userChoose"
                :key="i"
                >{{ i }}</span
              >
            </span>
            <span v-if="!item.userChoose.length">
              你的答案：<span class="false"> 未作答</span>
            </span>
            <span class="ml">
              正确答案：<span class="true" v-for="i in item.answer" :key="i">
                {{ i }}</span
              >
            </span>
          </template>
          <!-- 主观题 -->
          <template v-if="item.exerciseType === 3">
            <div class="t-color">参考答案：</div>
            <span>{{ item.answerText }}</span>
          </template>
        </div>
      </div>
      <div class="ceng-box" v-if="disabled"></div>
    </div>
    <!-- 按钮 -->
    <div class="btn" v-if="exercises.length">
      <van-button
        v-if="!readonly"
        color="#0F3CC6"
        round
        block
        @click="submit"
        :disabled="disabled"
        >提交</van-button
      >
      <van-button v-if="readonly" color="#0F3CC6" round block @click="examAgain"
        >再次练习</van-button
      >
    </div>
  </div>
  <van-overlay :show="showBig" z-index="9999">
    <div class="wrapper">
      <div class="close" @click="showBig = false">
        <van-image
          width="24"
          height="24"
          :src="require('@/assets/H5/play/close.png')"
        />
      </div>
      <div class="box">
        <div class="block">
          <van-image width="375" fit="scale-down" :src="bigImg" />
        </div>
      </div>
    </div>
  </van-overlay>
  <van-dialog
    v-model:show="qrObj.showDialog"
    :showConfirmButton="false"
    :showCancelButton="false"
  >
    <div style="text-align: right; padding: 20px 20px">
      <van-icon @click="qrObj.showDialog = false" name="cross" />
    </div>
    <div class="qrImg-box">
      <img :src="qrObj.qrImg" alt="" />
    </div>
    <div class="qr-remark">
      {{ qrObj.qrRemark }}
    </div>
  </van-dialog>
</template>
<script>
import { defineComponent, ref, onMounted, watch, onBeforeUnmount } from "vue";
import { Toast } from "vant";
import { getExercise, exerciseCommit } from "@/api/other";
export default defineComponent({
  props: {
    id: Number,
    current: String,
  },
  setup(props, { emit }) {
    const active = ref(0);

    let exercises = ref([]);

    onMounted(() => {
      if (props.id) {
        getList();
      }
    });

    onBeforeUnmount(() => {
      saveList();
    });

    watch(
      () => props.id,
      () => {
        if (props.id) {
          getList();
        }
      }
    );

    // 获取题目
    const getList = async () => {
      try {
        let { results } = await getExercise({
          courseId: props.id,
        });
        readonly.value = false;
        disabled.value = false;
        if (results.id) {
          param.value.exerciseId = results.id;
          let old = sessionStorage.getItem(props.id)
            ? JSON.parse(sessionStorage.getItem(props.id))
            : {};
          if (old.exerciseId == param.value.exerciseId) {
            exercises.value = old.exercises;
          } else {
            exercises.value = results.exercises;
          }
          emit("over", true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    // 保存当前做题情况
    const saveList = () => {
      sessionStorage.setItem(
        props.id,
        JSON.stringify({
          p_id: props.id,
          exerciseId: param.value.exerciseId,
          exercises: exercises.value,
        })
      );
    };

    let showBig = ref(false);
    let bigImg = ref("");
    const lookBigImg = (item) => {
      bigImg.value = item.fileUrl;
      showBig.value = true;
    };

    let qrObj = ref({
      showDialog: false,
      qrImg: "",
      qrRemark: "",
    });
    let param = ref({});
    let readonly = ref(false);
    let disabled = ref(false);
    const submit = async () => {
      param.value.answers = [];
      exercises.value.forEach((item) => {
        param.value.answers.push({
          userChoose:
            typeof item.userChooseIds == "number"
              ? [item.userChooseIds]
              : item.userChooseIds,
          questionId: item.id,
          userInput: item.userInput,
        });
      });

      try {
        let { results } = await exerciseCommit(param.value);
        readonly.value = true;
        disabled.value = true;
        // 提交成功后拿答案,将单选题的userChooseIds改为number类型
        results.exercises.forEach((item) => {
          if (item.exerciseType === 1) {
            item.userChooseIds = Number(item.userChooseIds);
          }
        });
        exercises.value = results.exercises;
        Toast.success("提交成功");
        if (results.qrCodeButton) {
          qrObj.value.showDialog = true;
          qrObj.value.qrImg = results.qrCodeUrl;
          qrObj.value.qrRemark = results.qrCodeText;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const examAgain = async () => {
      readonly.value = false;
      disabled.value = false;
      try {
        let { results } = await getExercise({
          courseId: props.id,
        });
        exercises.value = results.exercises;
        param.value.exerciseId = results.id;
      } catch (error) {
        console.log(error);
      }
    };

    return {
      qrObj,
      active,
      exercises,
      submit,
      examAgain,
      readonly,
      disabled,
      showBig,
      bigImg,
      lookBigImg,
    };
  },
});
</script>
<style lang="less" scoped>
.exercise-wrapper {
  // background: #fff;
  min-height: 100%;
  .list {
    position: relative;
    .item {
      .title-div {
        margin-top: 24px;
        .title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
          line-height: 22px;
        }
        .type {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0f3cc6;
          line-height: 20px;
        }
      }
      .img {
        margin-top: 10px;
      }
      .xuanxiang {
        .van-checkbox,
        .van-radio {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          line-height: 22px;
          margin-top: 24px;
          word-break: break-all;
        }
        .van-field {
          width: 343px;
          min-height: 84px;
          background: #f7f7f7;
          border-radius: 8px;
          margin-top: 10px;
        }
      }
      .answerDiv {
        margin-top: 24px;
        padding: 6px 10px;
        width: 343px;
        background: rgba(15, 60, 198, 0.15);
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        word-break: break-all;

        .t-color {
          color: #0f3cc6;
          margin-bottom: 8px;
        }
        .true {
          color: rgba(15, 60, 198, 1);
        }
        .false {
          color: rgb(233 53 43);
        }
        .ml {
          margin-left: 30px;
        }
      }
    }
    .ceng-box {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }
  .btn {
    margin: 24px 0 50px 0;
    font-size: 16px;
  }
}
.qrImg-box {
  display: flex;
  justify-content: center;
  img {
    width: 200px;
    height: 200px;
  }
}
.qr-remark {
  padding: 20px;
  text-align: center;
}

.wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
  .box {
    position: absolute;
    width: 375px;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
  }
  .close {
    padding-left: 20px;
    padding-top: 24px;
  }
}

.block {
  width: 375px;
}
</style>
